module.exports = __webpack_public_path__ + "img/onboarding-icon-glasses.24ffbf2f.svg";